<!-- src/App.vue -->
<template>
  <div>

    <!-- 方案2：简化结构（推荐） -->
    <div class="main-wrapper">
      <router-view />
    </div>

  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue' // 新增 watch
import { useRouter } from 'vue-router'
import { ElMessageBox, ElMessage } from 'element-plus'
import Cookies from 'js-cookie'
import axios from 'axios';
import config from '@/config.js';
export default {
  name: 'App',
  setup() {
    const router = useRouter()
    // 基于 Cookies 判断登录状态
    const isLoggedIn = ref(!!Cookies.get('user_token'))


    // 获取并设置网站图标和标题
    const fetchWebConfig = async () => {
      try {
        // 获取当前域名
        const currentDomain = window.location.hostname;

        // 通过 URL 参数传递域名，而不是请求头
        const response = await axios.get(`${config.BASE_URL}/shop/api/web_icon.php`, {
          params: {
            domain: currentDomain
          }
        })

        if (response.data.success) {
          const { shop_name, h5_favicon } = response.data.data

          // 设置浏览器标题
          document.title = shop_name

          // 设置浏览器图标
          const favicon = document.querySelector("link[rel*='icon']") || document.createElement('link')
          favicon.type = 'image/x-icon'
          favicon.rel = 'shortcut icon'
          favicon.href = h5_favicon
          document.getElementsByTagName('head')[0].appendChild(favicon)
        }
      } catch (error) {
        console.error('获取网站配置失败:', error)
        // 设置默认标题
        document.title = '碰一碰商业版'
      }
    }

    // 新增：监听 Cookie 变化
    const checkLoginStatus = () => {
      isLoggedIn.value = !!Cookies.get('user_token')
    }

    // 每秒检查一次（可根据需要调整频率）
    setInterval(checkLoginStatus, 300)

    // 或使用更高效的 watch
    // 修复后的 watch 监听
    watch(
      () => Cookies.get('user_token'), // 响应式依赖
      (newValue) => { // 参数名修正
        isLoggedIn.value = !!newValue
      }
    )
    const handleLogout = async () => {
      try {
        // 二次确认弹窗
        await ElMessageBox.confirm(
          '确定要退出登录吗？所有未保存数据将会丢失！',
          '警告',
          {
            confirmButtonText: '确认退出',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'logout-confirm',
            closeOnClickModal: false
          }
        )

        // 清除登录状态
        Cookies.remove('user_token')
        Cookies.remove('user_info')
        isLoggedIn.value = false

        // 跳转登录页并提示
        router.push('/login')
        ElMessage.success('您已安全退出系统')
      } catch (error) {
        // 用户取消退出时不执行操作
        if (error !== 'cancel') {
          ElMessage.error('退出操作失败，请重试')
        }
      }
    }
    // 在组件挂载时获取配置
    onMounted(() => {
      fetchWebConfig()
    })
    return {
      isLoggedIn,
      handleLogout
    }
  }
}
</script>

<style scoped>
.main-wrapper {
  min-height: 100vh;
  box-sizing: border-box;
  margin: -8px;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.el-upload__tip {
  margin-top: 0 !important;
}
</style>